export default "__VITE_ASSET__56928286__"